/**
 * deviceId for anonymous users. Persisted to AsyncStorage (works on native and web).
 * Used for future anonymous → registered upgrade flow.
 */
import AsyncStorage from '@react-native-async-storage/async-storage';
import { generatePrefixedId } from './id';

const DEVICE_ID_KEY = 'deviceId';

let cached: string | null = null;

export async function getOrCreateDeviceId(): Promise<string> {
  if (cached) return cached;
  try {
    const existing = await AsyncStorage.getItem(DEVICE_ID_KEY);
    if (existing && existing.length > 0) {
      cached = existing;
      return existing;
    }
    const id = generatePrefixedId('device');
    await AsyncStorage.setItem(DEVICE_ID_KEY, id);
    cached = id;
    return id;
  } catch {
    const id = generatePrefixedId('device');
    cached = id;
    return id;
  }
}

export function getDeviceIdCached(): string | null {
  return cached;
}
